/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Template_SubtitleInputs */

const en_transcript_export_template_subtitle = /** @type {(inputs: Transcript_Export_Template_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle`)
};

const fr_transcript_export_template_subtitle = /** @type {(inputs: Transcript_Export_Template_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titre`)
};

const de_transcript_export_template_subtitle = /** @type {(inputs: Transcript_Export_Template_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel`)
};

const it_transcript_export_template_subtitle = /** @type {(inputs: Transcript_Export_Template_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitolo`)
};

const ru_transcript_export_template_subtitle = /** @type {(inputs: Transcript_Export_Template_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Субтитры`)
};

const es_transcript_export_template_subtitle = /** @type {(inputs: Transcript_Export_Template_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitular`)
};

const zh_cn2_transcript_export_template_subtitle = /** @type {(inputs: Transcript_Export_Template_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕`)
};

const ja_transcript_export_template_subtitle = /** @type {(inputs: Transcript_Export_Template_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕`)
};

const hi_transcript_export_template_subtitle = /** @type {(inputs: Transcript_Export_Template_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक`)
};

const pt_pt2_transcript_export_template_subtitle = /** @type {(inputs: Transcript_Export_Template_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legenda`)
};

/**
* | output |
* | --- |
* | "Subtitle" |
*
* @param {Transcript_Export_Template_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_template_subtitle = /** @type {((inputs?: Transcript_Export_Template_SubtitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Template_SubtitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_template_subtitle(inputs)
	if (locale === "de") return de_transcript_export_template_subtitle(inputs)
	if (locale === "it") return it_transcript_export_template_subtitle(inputs)
	if (locale === "ru") return ru_transcript_export_template_subtitle(inputs)
	if (locale === "es") return es_transcript_export_template_subtitle(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_template_subtitle(inputs)
	if (locale === "ja") return ja_transcript_export_template_subtitle(inputs)
	if (locale === "hi") return hi_transcript_export_template_subtitle(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_template_subtitle(inputs)
	return en_transcript_export_template_subtitle(inputs)
});